import contactUs from "./contactUs";

const contactUsService = [
    {
        matcher: 'contactUs',
        reply: config => {
            return [200, contactUs];
        }
    }
]

export default contactUsService;